import { ApiService } from 'src/app/services/api.service';
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HeaderComponent } from '../header/header.component';
import { ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { LocalstorageService } from 'src/app/services/localstorage.service';

@Component({
  selector: 'app-welcome',
  standalone: true,
  imports: [CommonModule, HeaderComponent, ReactiveFormsModule],
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.scss'
})
export class WelcomeComponent {

  validationForm: FormGroup
  error: string = ''

  constructor(private apiService: ApiService, private formBuilder: FormBuilder, private route: Router, private localService: LocalstorageService) {
    this.validationForm = this.formBuilder.group({
      companyName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      employeeCode: ['', Validators.required]
    })
  }

  validateUser() {
    const userDetails = {
      email: this.validationForm.get('email')?.value,
      employeeCode: this.validationForm.get('employeeCode')?.value,
      organisation: this.validationForm.get('companyName')?.value.toUpperCase()
    }

    this.apiService.validateUser(userDetails).subscribe(
      (res: any) => {
        const userDetails = {
          email: this.validationForm.get('email')?.value,
          employeeCode: this.validationForm.get('employeeCode')?.value
        }
        this.localService.setEmployeeDetails(userDetails)
        this.route.navigate(['/'])
      },
      (error: any) => {
        this.error = 'You are not Identified as an Employee. Please Check Your Details!'
      }
    );
  }

}
